import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';
import { FormHelperText } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { useTheme } from '@mui/material/styles';
import { useApiTrigger } from '../../hooks/useApiTrigger';
import { useCachedData } from '../../hooks/useCachedData';
import { ensureArray } from '../../utils/validateResponseApi';

export function MultipleSelect({
    field,
    companyInfo,
    values,
    errorInputs,
    handleChange,
    label = 'Seleccione...'
}) {
    const theme = useTheme();
    const [options, setOptions] = useState([]);
    const selectedValues = Array.isArray(values)
        ? values
        : (typeof values === 'string' && values
            ? values.split(',').map((entry) => entry.trim()).filter(Boolean)
            : []);
    const { get, set } = useCachedData();
    const { getDataRequest } = useApiTrigger();

    const triggerConfig = field?.trigger?.[0];
    const path = field?.path || `${companyInfo.companySelectedId}.${field.id}`;
    // const defaultValueConfig = field?.defaultValue;

    const fetchOptions = async () => {
        const dataOptions = await getDataRequest(field, companyInfo);

        // if (defaultValueConfig) {
        //     const defaultOption = dataOptions[fieldId]?.find((o) => o.defaultValue);
        //     if (defaultOption) handleChanges(fieldId, defaultOption.code || '');
        // }

        setOptions(dataOptions);
        if (path) {
            set(path, dataOptions);
        }
    };

    useEffect(() => {
        if (!triggerConfig) return;

        const cached = path ? ensureArray(get(path)) : [];
        console.log('Multiple_select', path, cached)
        if (cached.length > 0) {
            setOptions(cached);
        } else {
            fetchOptions();
        }
    }, [companyInfo]);

    return (
        <>
            {options.length > 0 && selectedValues ? (
                <FormControl
                    fullWidth
                    size="small"
                    error={Boolean(errorInputs[field.id]?.isError)}
                >
                    <Autocomplete
                        multiple
                        size="small"
                        id="multiple-autocomplete"
                        options={options}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.name}
                        value={options.filter((item) => selectedValues.some((v) => String(v) === String(item.code)))}
                        onChange={(event, newValue) => {
                            handleChange({
                                target: {
                                    name: field.id,
                                    value: newValue.map((item) => item.code),
                                }
                            });
                        }}
                        renderTags={(tagValue, getTagProps) =>
                            tagValue.map((option, index) => (
                                <Chip
                                    variant="filled"
                                    color="primary"
                                    label={option.name}
                                    {...getTagProps({ index })}
                                    size="small"
                                />
                            ))
                        }
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                <span
                                    style={{
                                        fontWeight: selected ? 600 : 400,
                                        color: selected ? theme.palette.primary.main : 'inherit',
                                    }}
                                >
                                    {option.name}
                                </span>
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={label}
                                placeholder="Escribe para buscar"
                                required={field?.required}
                                error={Boolean(errorInputs[field.id]?.isError)}
                            />
                        )}
                        isOptionEqualToValue={(option, value) => option.code === value.code}
                    />
                    {Boolean(errorInputs[field.id]?.isError) && <FormHelperText>{errorInputs[field.id]?.messageError}</FormHelperText>}
                </FormControl>
            ) : (
                <Autocomplete
                    multiple
                    options={[]}
                    renderInput={(params) => (
                        <TextField {...params} label={label} />
                    )}
                />
            )}
        </>
    );
}
